import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "splash-screen" }
const _hoisted_2 = {
  class: "mb-4",
  style: {"width":"400px","height":"300px"}
}
const _hoisted_3 = { class: "w-50 mt-6" }

import loadingImage from '@/assets/images/explore/loading-image.svg'

export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "h-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center",
          class: "h-100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex flex-column justify-center align-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_img, {
                    src: _unref(loadingImage),
                    alt: "Loading",
                    width: "400",
                    height: "300",
                    contain: "",
                    eager: ""
                  }, null, 8, ["src"])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-grey font-weight-regular" }, " Just a moment ", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("h2", {
                  style: {"color":"#141414"},
                  class: "primary--font font-weight-regular mt-4 mb-4"
                }, "Preparing an optimised workspace for you", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_progress_linear, {
                    color: "blue-darken-1",
                    height: "6",
                    indeterminate: "",
                    rounded: ""
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})